// extracted by mini-css-extract-plugin
module.exports = {"form":"HubspotForm_form__U401s","inverted":"HubspotForm_inverted__dywnp"};